// src/pages/Leite/propriedade/acoesSugestao.js
import { PAGINAS_COLETA } from '../../../utils/coleta';

/**
 * Para onde leva o botão de uma sugestão do assistente (acao.tipo vem do backend):
 *  ABRIR_PLANO           → /acoes?novo=<amostra>  (a ação nasce com o "antes")
 *  VER_PLANOS            → /acoes
 *  REGISTRAR_VERIFICACAO → /<página>?registrar=1  (nova coleta de verificação)
 *  VER_AMOSTRA           → /<página>/<amostra>
 */
export const rotaDaAcao = (tenant, acao) => {
    if (!acao) return null;
    const rota = PAGINAS_COLETA[acao.pagina]?.rota;
    switch (acao.tipo) {
        case 'ABRIR_PLANO':
            return acao.amostraId ? `/${tenant}/acoes?novo=${acao.amostraId}` : `/${tenant}/acoes`;
        case 'VER_PLANOS':
            return `/${tenant}/acoes`;
        case 'REGISTRAR_VERIFICACAO':
            return rota ? `/${tenant}/${rota}?registrar=1` : null;
        case 'VER_AMOSTRA':
            return rota && acao.amostraId ? `/${tenant}/${rota}/${acao.amostraId}` : null;
        default:
            return null;
    }
};

const ICONES = {
    ABRIR_PLANO: 'ClipboardPlus',
    VER_PLANOS: 'ClipboardList',
    REGISTRAR_VERIFICACAO: 'ClipboardCheck',
    VER_AMOSTRA: 'FlaskConical',
};

export const iconeDaAcao = (acao) => ICONES[acao?.tipo] || 'ArrowRight';
